import { render, staticRenderFns } from "./SGPModalComponent.vue?vue&type=template&id=0448407f"
import script from "./SGPModalComponent.vue?vue&type=script&lang=js"
export * from "./SGPModalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports